const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9F3FF"
    },
    d: "M622.838,446.053h-506.17c-43.656-57.856-49.348-135.14-17.166-198.322 c9.644-18.933,25.531-38.409,49.276-41.521c19.121-2.507,37.75,6.416,57.06,7.372c29.81,1.477,56.688-16.256,74.346-36.98 c17.659-20.724,29.062-44.98,46.548-65.813c32.848-39.135,87.46-64.069,143.527-65.529 c56.067-1.461,112.331,20.585,147.869,57.938c29.986,31.518,44.813,72.063,50.131,112.542 c5.319,40.479,1.781,81.381-1.246,122.034C664.488,371.687,648.897,417.33,622.838,446.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9F3FF"
    },
    d: "M220.723,186.226c21.742-6.505,38.686-21.278,53.218-36.642 c13.538-14.313,26.063-30.237,29.621-48.438c3.557-18.201-4.023-39.104-22.74-48.112c-16.095-7.745-36.417-5.193-53.368,1.055 c-24.927,9.188-45.955,25.996-58.443,46.714c-11.438,18.976-19.093,47.831-11.122,68.931 C165.501,189.885,201.426,192,220.723,186.226z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BC5FF"
    },
    d: "M523.694,446.053H226.306V84.625c0-5.523,4.477-10,10-10h277.388c5.523,0,10,4.477,10,10V446.053 z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.619,
    y: 149.173,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 646.6722 -103.3278)",
    style: {
      fill: "#B9F3FF"
    },
    width: 348.761,
    height: 244.999
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#96E4FF"
    },
    cx: 375,
    cy: 136.693,
    r: 28.764
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "394.763,130.17 381.523,130.17 381.523,116.931 368.477,116.931 368.477,130.17  355.237,130.17 355.237,143.217 368.477,143.217 368.477,156.456 381.523,156.456 381.523,143.217 394.763,143.217  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.975,
    y: 173.84,
    style: {
      fill: "#96E4FF"
    },
    width: 76.691,
    height: 4.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.975,
    y: 183.046,
    style: {
      fill: "#96E4FF"
    },
    width: 60.275,
    height: 4.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.975,
    y: 205.476,
    style: {
      fill: "#96E4FF"
    },
    width: 76.691,
    height: 4.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.975,
    y: 214.682,
    style: {
      fill: "#96E4FF"
    },
    width: 69.275,
    height: 4.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.975,
    y: 237.113,
    style: {
      fill: "#96E4FF"
    },
    width: 76.691,
    height: 4.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.975,
    y: 246.319,
    style: {
      fill: "#96E4FF"
    },
    width: 51.525,
    height: 4.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.975,
    y: 268.749,
    style: {
      fill: "#96E4FF"
    },
    width: 76.691,
    height: 4.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.975,
    y: 277.955,
    style: {
      fill: "#96E4FF"
    },
    width: 69.275,
    height: 4.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.975,
    y: 300.386,
    style: {
      fill: "#96E4FF"
    },
    width: 76.691,
    height: 4.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.975,
    y: 309.592,
    style: {
      fill: "#96E4FF"
    },
    width: 60.275,
    height: 4.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 412.013,
    y: 173.84,
    style: {
      fill: "#96E4FF"
    },
    width: 76.691,
    height: 4.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.013,
    y: 183.046,
    style: {
      fill: "#96E4FF"
    },
    width: 60.275,
    height: 4.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 412.013,
    y: 205.476,
    style: {
      fill: "#96E4FF"
    },
    width: 76.691,
    height: 4.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.013,
    y: 214.682,
    style: {
      fill: "#96E4FF"
    },
    width: 69.275,
    height: 4.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 412.013,
    y: 237.113,
    style: {
      fill: "#96E4FF"
    },
    width: 76.691,
    height: 4.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.013,
    y: 246.319,
    style: {
      fill: "#96E4FF"
    },
    width: 51.525,
    height: 4.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 412.013,
    y: 268.749,
    style: {
      fill: "#96E4FF"
    },
    width: 76.691,
    height: 4.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.013,
    y: 277.955,
    style: {
      fill: "#96E4FF"
    },
    width: 69.275,
    height: 4.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 412.013,
    y: 300.386,
    style: {
      fill: "#96E4FF"
    },
    width: 76.691,
    height: 4.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.013,
    y: 309.592,
    style: {
      fill: "#96E4FF"
    },
    width: 60.275,
    height: 4.993
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.113,
    y: 171.223,
    style: {
      fill: "#96E4FF"
    },
    width: 20.482,
    height: 20.482
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BC5FF"
    },
    d: "M390.187,187.792c-0.398,0-0.779-0.158-1.061-0.439l-7.459-7.459 c-0.586-0.585-0.586-1.536,0-2.121c0.586-0.586,1.535-0.586,2.121,0l6.399,6.398l15.55-15.55 c0.586-0.586,1.535-0.586,2.121,0c0.586,0.585,0.586,1.536,0,2.121l-16.61,16.611 C390.966,187.633,390.584,187.792,390.187,187.792z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.113,
    y: 202.848,
    style: {
      fill: "#96E4FF"
    },
    width: 20.482,
    height: 20.482
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BC5FF"
    },
    d: "M390.187,219.417c-0.398,0-0.779-0.158-1.061-0.439l-7.459-7.459 c-0.586-0.585-0.586-1.536,0-2.121c0.586-0.586,1.535-0.586,2.121,0l6.399,6.398l15.55-15.55 c0.586-0.586,1.535-0.586,2.121,0c0.586,0.585,0.586,1.536,0,2.121l-16.61,16.611 C390.966,219.258,390.584,219.417,390.187,219.417z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.113,
    y: 234.473,
    style: {
      fill: "#96E4FF"
    },
    width: 20.482,
    height: 20.482
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BC5FF"
    },
    d: "M390.187,251.042c-0.398,0-0.779-0.158-1.061-0.439l-7.459-7.459 c-0.586-0.585-0.586-1.536,0-2.121c0.586-0.586,1.535-0.586,2.121,0l6.399,6.398l15.55-15.55 c0.586-0.586,1.535-0.586,2.121,0c0.586,0.585,0.586,1.536,0,2.121l-16.61,16.611 C390.966,250.883,390.584,251.042,390.187,251.042z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.113,
    y: 266.098,
    style: {
      fill: "#96E4FF"
    },
    width: 20.482,
    height: 20.482
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BC5FF"
    },
    d: "M390.187,282.667c-0.398,0-0.779-0.158-1.061-0.439l-7.459-7.459 c-0.586-0.586-0.586-1.536,0-2.121c0.586-0.586,1.535-0.586,2.121,0l6.399,6.398l15.55-15.55 c0.586-0.586,1.535-0.586,2.121,0c0.586,0.586,0.586,1.536,0,2.121l-16.61,16.611 C390.966,282.508,390.584,282.667,390.187,282.667z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.113,
    y: 297.723,
    style: {
      fill: "#96E4FF"
    },
    width: 20.482,
    height: 20.482
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BC5FF"
    },
    d: "M390.187,314.292c-0.398,0-0.779-0.158-1.061-0.439l-7.459-7.459 c-0.586-0.586-0.586-1.536,0-2.121c0.586-0.586,1.535-0.586,2.121,0l6.399,6.398l15.55-15.55 c0.586-0.586,1.535-0.586,2.121,0c0.586,0.586,0.586,1.536,0,2.121l-16.61,16.611 C390.966,314.133,390.584,314.292,390.187,314.292z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 323.333,
    y: 78.292,
    style: {
      fill: "#96E4FF"
    },
    width: 103.333,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.333,
    y: 65.375,
    style: {
      fill: "#6BC5FF"
    },
    width: 103.333,
    height: 12.917
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.333,
    y: 97.292,
    style: {
      fill: "#6BC5FF"
    },
    width: 103.333,
    height: 12.917
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96E4FF"
    },
    d: "M375,36.375c-8.008,0-14.5,6.492-14.5,14.5v14.5h29v-14.5 C389.5,42.867,383.008,36.375,375,36.375z M375,56.542c-3.797,0-6.875-3.078-6.875-6.875c0-3.797,3.078-6.875,6.875-6.875 s6.875,3.078,6.875,6.875C381.875,53.464,378.797,56.542,375,56.542z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.833,237.625c8.384-2.113,18.867,2.639,25.387,8.318c6.519,5.68,11.024,13.265,15.417,20.713 c9.932,16.841,36.764,56.878,46.697,73.719l59.726-21.417l-10.415,48.667L344,393.292l-60.934-101L276.833,237.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E4E0"
    },
    d: "M345.169,373.074c-13.734-31.681-29.934-63.156-48.008-92.578 c4.06-5.405,5.63-12.607,4.187-19.212c-1.443-6.605-6.186-13.022-12.13-16.242c2.927-1.146,6.035-1.815,9.172-2.009 c-6.361-4.242-14.665-7.146-21.557-5.409l6.232,54.667l60.934,101l69.644-25.667l5.102-23.842 C396.239,357.741,371.071,367.403,345.169,373.074z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M396.718,387.087c-12.439-4.716-26.763-3.538-38.103,3.555 c-11.669,7.298-17.763,19.995-26.238,30.329c-4.951,6.036-10.728,10.861-18.202,13.435c-7.421,2.556-15.331,3.14-23.041,4.304 c-7.456,1.126-15.329,3.172-21.617,7.342h6.103c6.832-3.116,14.899-4.273,22.158-5.263c12.967-1.769,24.694-4.63,33.919-14.486 c8.381-8.955,13.727-20.42,22.811-28.757c11.174-10.255,27.358-12.895,41.413-7.566 C397.727,390.665,398.508,387.766,396.718,387.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454F6B"
    },
    d: "M412.649,316.137c8.726,15.988,35.341,13.237,35.341,13.237l0.693-9.625 C430.125,308.5,416.298,311.274,412.649,316.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M416.25,312.875l-7.5,48.25L350,446.053h44.5l36.745-34.553 c9.61-9.037,16.25-20.777,19.044-33.669l11.961-55.206L416.25,312.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M416.25,312.875l-1.48,9.525c10.232,0.5,20.321,3.868,28.769,9.669 c1.259,17.789-1.051,36.035-6.231,53.099c-7.393,24.356-27.975,42.75-46.951,60.885h4.144l36.745-34.553 c9.61-9.037,16.25-20.777,19.044-33.669l11.961-55.205L416.25,312.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454F6B"
    },
    d: "M444.562,400.159c1.815-2.708,2.076-6.144,0.742-9.119c-3.312-7.386-8.582-13.895-15.156-18.622 c-6.528-4.695-14.312-7.612-22.309-8.426c-3.262-0.332-6.439,1.191-8.35,3.855l-24.238,33.778 c-1.766,2.461-2.521,5.506-2.108,8.507l0.283,2.057l2.687-3.884c18.388,0.82,29.944,13.536,31.666,25.261l-2.918,2.744l0,0 c2.704,0,5.337-0.925,7.437-2.628C430.847,418.648,440.283,406.54,444.562,400.159z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M434.651,397.894c-0.051,0-0.102-0.016-0.146-0.047c-0.112-0.081-0.138-0.237-0.058-0.349 c1.373-1.912,2.716-3.882,3.99-5.853c0.075-0.117,0.23-0.148,0.346-0.074c0.116,0.075,0.149,0.229,0.074,0.346 c-1.278,1.979-2.626,3.955-4.004,5.873C434.806,397.857,434.728,397.894,434.651,397.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M411.493,423.2c-0.07,0-0.14-0.029-0.19-0.087c-0.09-0.105-0.078-0.263,0.026-0.353 c6.938-5.979,13.345-12.66,19.044-19.86c0.087-0.109,0.244-0.125,0.352-0.041c0.108,0.086,0.126,0.243,0.041,0.352 c-5.719,7.225-12.148,13.93-19.11,19.929C411.609,423.181,411.551,423.2,411.493,423.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M489.841,254.023c3.913,4.919,9.981,8.09,16.26,8.372c6.279,0.282,12.654-2.367,16.793-7.097 c3.755-4.289,5.502-9.827,6.706-15.474l-6.6-2.2l-1.5-34.814l-31.632,16.806l1.238,19.001c-2.074,0.224-4.157,0.46-6.242,0.699 C484.82,244.595,486.555,249.891,489.841,254.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M489.868,219.617l31.632-16.806l0.094,2.19c-1.683,5.073-4.873,11.157-8.056,15.451 c-2.071,2.795-4.465,5.402-7.38,7.3c-2.915,1.898-6.397,3.052-9.865,2.784c-2.168-0.167-4.113-0.878-5.856-2.161 L489.868,219.617z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M499.145,249.769c-0.086,0-0.171-0.045-0.217-0.125c-2.675-4.657-4.481-9.931-5.225-15.251 c-0.019-0.137,0.077-0.263,0.214-0.282c0.146-0.015,0.264,0.077,0.282,0.213c0.733,5.257,2.519,10.468,5.162,15.07 c0.068,0.12,0.027,0.273-0.092,0.342C499.23,249.758,499.188,249.769,499.145,249.769z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M505.353,254.135c-0.036,0-0.073-0.008-0.108-0.024c-0.124-0.06-0.177-0.209-0.117-0.334 c3.45-7.209,5.341-15.245,5.467-23.238c0.002-0.138,0.109-0.274,0.254-0.246c0.138,0.002,0.248,0.116,0.246,0.254 c-0.127,8.064-2.034,16.173-5.516,23.447C505.536,254.082,505.446,254.135,505.353,254.135z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M460.903,190.374c-1.205-1.016-2.863-1.473-4.419-1.217c-1.556,0.256-2.98,1.22-3.796,2.569 c-1.173,1.939-1.007,4.52,0.138,6.476c1.145,1.956,3.152,3.313,5.315,3.99c2.163,0.676,4.48,0.723,6.735,0.498 C463.646,198.808,462.132,194.256,460.903,190.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M466.963,203.454c-14.189-9.194-22.52-27.911-20.298-45.604 c0.989-7.875,3.913-15.463,8.421-21.749c7.025-9.795,17.941-16.227,29.378-17.311c11.437-1.084,23.225,3.197,31.727,11.52 c5.805-2.866,13.557,0.115,18.504,4.469c4.947,4.354,7.786,11.064,8.666,17.885c0.88,6.821-0.046,13.779-1.593,20.46 c-1.246,5.383-2.961,10.789-6.223,15.08c-5.277,6.942-13.753,9.94-21.887,11.84 C499.11,203.445,479.725,211.723,466.963,203.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M455.152,174.455c2.278,11.62,4.672,23.538,10.977,33.56 c6.305,10.023,17.488,17.879,29.276,16.761c7.07-0.67,13.567-4.469,18.641-9.438c5.074-4.969,8.882-11.068,12.41-17.231 c3.021,3.368,9.215,3.826,13.134,1.566c3.919-2.26,6.151-6.924,5.984-11.445c-0.084-2.27-0.764-4.602-2.335-6.242 c-2.786-2.908-7.789-2.786-11.074-0.457c-3.285,2.329-5.035,6.33-5.656,10.309c-2.696-2.077-4.354-5.418-3.453-8.699 c-4.242-2.323-7.941-6.206-10.014-10.576c-2.073-4.37-2.728-9.398-1.844-14.153c-4.077,5.087-10.329,8.585-16.564,10.491 c2.401-2.253,3.958-5.152,5.016-8.269C486.647,168.775,470.493,174.468,455.152,174.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M483.814,195.5h-9.064c0.178,1.188,1.371,2.279,2.494,2.706s2.412,0.308,3.507-0.188 S483.109,196.473,483.814,195.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M500.367,202.053c-7.624,2.18-15.423,3.748-23.298,4.683c1.299,2.238,3.272,4.214,5.666,5.195 c2.394,0.982,5.115,1.148,7.611,0.466c2.383-0.651,4.529-2.05,6.24-3.832C498.297,206.783,499.402,204.328,500.367,202.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M541.085,185.007c-1.945-0.06-3.902,0.677-5.325,2.005c-1.423,1.327-2.293,3.229-2.368,5.174 c-0.034,0.887,0.107,1.819,0.626,2.539c0.52,0.72,1.487,1.164,2.327,0.875c0.603-0.207,1.036-0.736,1.367-1.281 c0.611-1.006,0.99-2.219,0.728-3.367c-0.262-1.148-1.302-2.159-2.479-2.108C537.13,187.036,539.003,185.549,541.085,185.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M541.093,184.756c-2.025-0.071-4.025,0.693-5.504,2.072c-1.478,1.379-2.369,3.328-2.446,5.346 c-0.043,1.11,0.184,2.017,0.673,2.695c0.484,0.671,1.255,1.066,1.991,1.066c0.212,0,0.422-0.033,0.62-0.101 c0.131-0.045,0.2-0.187,0.155-0.318c-0.044-0.131-0.19-0.2-0.317-0.155c-0.777,0.268-1.615-0.191-2.043-0.785 c-0.423-0.585-0.617-1.387-0.579-2.383c0.063-1.647,0.706-3.243,1.786-4.48c1.37-0.314,2.77-0.376,4.163-0.184 c0.15,0.02,0.263-0.077,0.282-0.213c0.019-0.137-0.077-0.263-0.214-0.282c-1.205-0.168-2.414-0.141-3.607,0.055 c1.371-1.221,3.208-1.895,5.024-1.834c0.135-0.011,0.254-0.104,0.258-0.242C541.339,184.876,541.23,184.761,541.093,184.756z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M505.489,148.83c-0.03,0-0.061-0.005-0.09-0.017c-11.966-4.609-25.267-4.952-37.451-0.966 c-0.135,0.043-0.272-0.029-0.315-0.16c-0.043-0.131,0.028-0.272,0.159-0.315c12.295-4.02,25.715-3.673,37.787,0.975 c0.129,0.05,0.193,0.194,0.144,0.323C505.685,148.769,505.59,148.83,505.489,148.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M506.741,146.26c-0.06,0-0.119-0.021-0.167-0.064c-5.849-5.266-13.99-7.777-21.794-6.72 c-0.13,0.025-0.262-0.078-0.281-0.214c-0.018-0.137,0.077-0.263,0.215-0.281c7.942-1.076,16.238,1.481,22.194,6.844 c0.102,0.092,0.111,0.25,0.019,0.353C506.878,146.232,506.81,146.26,506.741,146.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M507.797,143.724c-0.087,0-0.172-0.046-0.218-0.127c-1.315-2.336-3.519-4.192-6.045-5.092 c-0.13-0.046-0.198-0.189-0.151-0.319c0.047-0.13,0.193-0.199,0.319-0.151c2.639,0.94,4.94,2.878,6.313,5.318 c0.067,0.12,0.025,0.272-0.095,0.34C507.881,143.713,507.839,143.724,507.797,143.724z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M510.259,141.435c-0.09,0-0.178-0.049-0.222-0.135c-2.392-4.618-7.064-8.01-12.194-8.852 c-0.137-0.023-0.23-0.151-0.207-0.287c0.023-0.135,0.145-0.228,0.287-0.206c5.284,0.867,10.096,4.36,12.558,9.116 c0.063,0.123,0.016,0.273-0.107,0.337C510.337,141.426,510.298,141.435,510.259,141.435z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M522.7,152.292c-0.071,0-0.143-0.031-0.192-0.09c-1.956-2.351-5.072-3.743-8.125-3.619 c-0.133-0.005-0.254-0.102-0.26-0.24c-0.005-0.138,0.103-0.254,0.24-0.26c3.214-0.122,6.476,1.332,8.529,3.798 c0.088,0.106,0.073,0.264-0.032,0.352C522.813,152.273,522.757,152.292,522.7,152.292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M529.337,150.781c-0.072,0-0.145-0.031-0.193-0.092c-3.4-4.162-9.346-5.917-14.462-4.266 c-0.136,0.045-0.273-0.029-0.315-0.161c-0.042-0.131,0.03-0.272,0.161-0.314c5.304-1.712,11.476,0.107,15.003,4.425 c0.088,0.107,0.071,0.265-0.035,0.352C529.448,150.763,529.393,150.781,529.337,150.781z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M515.229,144.322c-0.101,0-0.195-0.061-0.233-0.161c-0.05-0.129,0.015-0.273,0.143-0.323 c1.871-0.716,3.91-0.954,5.891-0.692c0.137,0.018,0.232,0.144,0.215,0.281c-0.019,0.136-0.135,0.229-0.281,0.215 c-1.897-0.253-3.853-0.023-5.645,0.663C515.289,144.317,515.26,144.322,515.229,144.322z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495375"
    },
    d: "M528.389,142.105c-0.05,0-0.1-0.015-0.144-0.045c-3.479-2.447-8.472-2.655-12.141-0.506 c-0.117,0.069-0.273,0.029-0.342-0.089c-0.069-0.119-0.029-0.273,0.09-0.342c3.833-2.243,9.048-2.026,12.68,0.529 c0.113,0.08,0.141,0.235,0.061,0.349C528.545,142.068,528.467,142.105,528.389,142.105z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M492.432,169.649c-1.19,1.601-2.675,3.406-4.426,4.362c7.933-0.551,15.362-3.781,20.686-9.688 c0.778,1.659,1.794,3.193,2.992,4.573c-0.947-3.399-1.131-7.013-0.486-10.483c-4.077,5.087-10.329,8.585-16.564,10.491 c2.401-2.253,3.958-5.152,5.016-8.269c-13.002,8.142-29.156,13.835-44.498,13.822c0.349,1.778,0.702,3.562,1.069,5.346 C468.957,180.37,481.856,176.774,492.432,169.649z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M494.915,174.027c-3.574,0.075-6.704,1.852-8.659,4.533l17.501-0.367 C501.69,175.596,498.488,173.952,494.915,174.027z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M468.001,174.027c-2.346,0.075-4.401,1.852-5.684,4.533l11.488-0.367 C472.449,175.596,470.347,173.952,468.001,174.027z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M494.375,189.75L494.375,189.75c-1.266,0-2.292-1.026-2.292-2.292v-1.417 c0-1.266,1.026-2.292,2.292-2.292l0,0c1.266,0,2.292,1.026,2.292,2.292v1.417C496.667,188.724,495.641,189.75,494.375,189.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M468.061,189.75L468.061,189.75c-1.012,0-1.832-0.82-1.832-1.832v-2.336 c0-1.012,0.82-1.832,1.832-1.832l0,0c1.012,0,1.832,0.82,1.832,1.832v2.336C469.893,188.93,469.073,189.75,468.061,189.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CA8BF"
    },
    d: "M576,255.292l-46.4-15.466c-1.205,5.647-2.952,11.184-6.706,15.474 c-4.14,4.73-10.514,7.379-16.793,7.097c-6.279-0.282-12.347-3.453-16.26-8.372c-3.286-4.132-5.021-9.428-4.978-14.706 c-8.034,0.92-16.136,1.93-24.216,2.911c-12.524,1.52-23.678,8.709-30.152,19.537c-9.895,16.549-16.298,35.343-17.845,54.372 c12.148-0.488,24.757,2.154,35.768,7.309L442,412.625l-7.333,33.428h144l6.175-43.746c1.877-13.299,2.205-26.77,0.976-40.144 L576,255.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#468097"
    },
    d: "M448.683,268.875c0.429,6.936-0.932,14.857-2.579,21.609c-1.555-0.49-3.456,0.487-4.482,1.754 c-1.026,1.267-1.444,2.921-1.63,4.541c-0.466,4.059,0.391,8.26,2.41,11.813c-4.028-1.694-8.217-2.403-12.565-2.837 c3.911,1.717,7.297,4.98,9.756,8.473c-5.699-0.14-11.342,0.675-16.803,2.219c8.859,0.865,17.661,3.271,25.628,7l0.266-3.697 C451,294.625,450.116,278.375,448.683,268.875z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M448.417,323.696c-0.006,0-0.012,0-0.018-0.001c-0.138-0.01-0.242-0.129-0.231-0.267 l0.267-3.697c1.197-12.995,1.643-24.748,1.324-34.938c-0.004-0.138,0.104-0.253,0.242-0.258 c0.147,0.01,0.254,0.103,0.258,0.242c0.319,10.21-0.127,21.983-1.326,34.993l-0.267,3.692 C448.657,323.596,448.547,323.696,448.417,323.696z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#468097"
    },
    d: "M585.818,362.163l-8.339-90.777l-20.966,12.566c-4.457,10.923-4.096,24.667,2.175,34.66 c-3.425-1.705-6.637-2.531-10.063-4.237c1.522,2.796,3.058,5.748,4.588,8.632c1.166,2.198,2.814,4.101,4.822,5.57 c3.501,2.562,5.849,6.403,6.534,10.687c4.23,26.441,2.285,53.503-5.681,79.067l-8.638,27.721h28.417l6.175-43.746 C586.719,389.008,587.046,375.537,585.818,362.163z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M530.284,254.391c-0.035,0-0.071-0.008-0.105-0.023c-0.125-0.058-0.18-0.207-0.121-0.332 c1.19-2.562,1.946-5.243,2.249-7.969c0.015-0.137,0.139-0.257,0.275-0.221c0.138,0.015,0.236,0.139,0.221,0.275 c-0.308,2.78-1.079,5.514-2.292,8.125C530.469,254.337,530.378,254.391,530.284,254.391z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M506.366,269.731c-4.042,0-8.083-0.893-11.727-2.688c-7.648-3.769-13.212-11.344-14.519-19.77 c-0.021-0.136,0.072-0.264,0.209-0.285c0.137-0.02,0.264,0.072,0.285,0.209c1.282,8.268,6.74,15.701,14.245,19.398 c7.508,3.698,16.726,3.497,24.062-0.525c3.037-1.666,5.803-4.046,7.998-6.881c0.083-0.11,0.241-0.13,0.351-0.044 c0.109,0.084,0.129,0.241,0.044,0.351c-2.236,2.889-5.056,5.314-8.152,7.012C515.248,268.653,510.807,269.731,506.366,269.731 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M541.08,333.967c-28.826,0-57.189-11.467-77.91-31.517c-0.1-0.096-0.102-0.254-0.006-0.353 c0.097-0.099,0.254-0.101,0.353-0.006c20.627,19.959,48.867,31.376,77.563,31.376c0.195,0,0.39-0.001,0.586-0.002h0.001 c0.138,0,0.249,0.111,0.25,0.249c0.001,0.138-0.11,0.25-0.249,0.251C541.474,333.966,541.274,333.967,541.08,333.967z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M513.182,319.497c-6.189,0-12.377-0.355-18.53-1.066c-0.138-0.016-0.236-0.14-0.22-0.276 c0.016-0.137,0.122-0.237,0.276-0.22c13.271,1.532,26.713,1.406,39.95-0.376c0.131-0.012,0.263,0.078,0.281,0.215 c0.018,0.137-0.078,0.263-0.215,0.281C527.584,319.016,520.382,319.497,513.182,319.497z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M510.315,393.999c-12.945,0-24.862-1.442-34.37-3.129c-0.129-0.022-0.219-0.142-0.205-0.272 c0.014-0.13,0.126-0.221,0.257-0.224c26.31,0.862,52.731-4.772,76.41-16.263c0.122-0.061,0.273-0.009,0.334,0.115 c0.061,0.124,0.009,0.274-0.115,0.334c-22.723,11.026-47.969,16.671-73.219,16.388c18.353,2.95,44.233,4.622,69.163-2.335 c0.134-0.032,0.271,0.041,0.309,0.174c0.037,0.133-0.041,0.271-0.174,0.309C535.769,392.704,522.58,393.999,510.315,393.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M495.757,383.3c-13.709,0-27.428-3.361-39.493-9.88c-0.121-0.065-0.166-0.217-0.101-0.339 c0.065-0.121,0.216-0.167,0.339-0.101c17.941,9.692,39.565,12.364,59.332,7.325c0.132-0.032,0.271,0.047,0.304,0.181 c0.034,0.134-0.047,0.27-0.181,0.304C509.362,382.472,502.56,383.3,495.757,383.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454F6B"
    },
    d: "M622.667,325.292c-10,22-35,22.667-47,19.667C574.5,318.958,612.667,312.458,622.667,325.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2C9AD"
    },
    d: "M575.75,336.875l19.25,48.25l-35.333,60.928H599l31.696-39.867 c7.266-9.14,9.361-21.358,5.553-32.395l-18.916-54.832L575.75,336.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M620.292,327.533l-2.958-8.575l-41.583,17.917l19.25,48.25l-8.801-40.802 C595.178,335.028,607.456,329.007,620.292,327.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CA8BF"
    },
    d: "M559.667,305.625l16,39.333c9.667-14.333,34-20.667,47-19.667 c-27.333-66.333-30.667-64.667-46.667-70C560,249.958,551.292,285.037,559.667,305.625z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M572.705,337.928c-0.099,0-0.192-0.059-0.232-0.156l-13.038-32.053 c-2.81-6.908-3.856-15.708-2.946-24.778c0.015-0.137,0.121-0.244,0.274-0.224c0.137,0.014,0.237,0.137,0.224,0.274 c-0.903,8.99,0.131,17.705,2.911,24.54l13.038,32.053c0.052,0.128-0.01,0.273-0.138,0.325 C572.769,337.922,572.736,337.928,572.705,337.928z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M575.652,331.636c-0.075,0-0.15-0.034-0.199-0.099c-0.083-0.11-0.061-0.267,0.048-0.351 c9.91-7.521,22.216-11.904,34.65-12.341c0.143,0.016,0.254,0.103,0.259,0.241c0.005,0.138-0.104,0.254-0.241,0.259 c-12.332,0.433-24.537,4.779-34.365,12.239C575.758,331.619,575.705,331.636,575.652,331.636z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M580.597,321.786c-0.074,0-0.147-0.033-0.197-0.096c-0.085-0.109-0.065-0.267,0.043-0.352 c5.606-4.384,12.607-7.011,19.714-7.399c0.005,0,0.01,0,0.014,0c0.132,0,0.242,0.103,0.25,0.236 c0.007,0.138-0.099,0.256-0.236,0.264c-7.005,0.382-13.907,2.973-19.433,7.294 C580.705,321.769,580.65,321.786,580.597,321.786z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M567.585,432.648c-0.043,0-0.086-0.011-0.125-0.034c-0.12-0.068-0.16-0.222-0.091-0.341 l34.33-59.198c0.068-0.12,0.223-0.161,0.341-0.091c0.12,0.068,0.16,0.222,0.091,0.341l-34.33,59.198 C567.755,432.603,567.671,432.648,567.585,432.648z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M159.25,446.053c3.24-43.42,14.962-89.563,25.984-131.685 c4.302-16.444,9.264-32.916,17.812-47.607c8.548-14.692,21.131-30.013,37.621-34.135c10.667-2.667,21.333,4.667,40.013,27.388 L291,358.292c1.667,35.667-5.667,87.761-5.667,87.761H159.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E4E0"
    },
    d: "M281.728,269.99l-36.171,11.934c-1.979,16.121,1.112,32.821,8.691,47.183 c-8.747,21.851-28.58,49.899-50.58,68.959c33.667-19.757,52.5-58.071,52.5-58.071C249.5,379.625,209,424.375,209,424.375 c33.25-17.75,51.5-64.76,51.5-64.76c6.271,11.804,8.945,25.723,8.679,39.087c-0.325,16.291-5.654,31.989-11.182,47.35h27.336 c0,0,7.333-52.094,5.667-87.761L281.728,269.99z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A59B95"
    },
    d: "M284.976,384.165c-0.319,2.669-2.105,4.651-3.99,4.426c-1.885-0.225-3.155-2.572-2.836-5.241 c0.319-2.669,2.105-4.651,3.99-4.426S285.294,381.496,284.976,384.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A59B95"
    },
    d: "M282.025,417.738c-0.319,2.669-2.105,4.651-3.99,4.426s-3.155-2.571-2.836-5.241 c0.319-2.669,2.105-4.651,3.99-4.426S282.344,415.069,282.025,417.738z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M189.341,387.358c-0.085,0-0.167-0.043-0.214-0.121c-0.071-0.118-0.034-0.272,0.084-0.343 c12.395-7.486,25.211-15.229,36.57-24.592c12.714-10.48,22.034-21.846,27.7-33.779c0.059-0.124,0.21-0.178,0.333-0.118 c0.124,0.059,0.178,0.208,0.119,0.333c-5.698,12-15.063,23.423-27.833,33.951c-11.387,9.386-24.22,17.137-36.629,24.633 C189.43,387.347,189.385,387.358,189.341,387.358z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M192.638,430.114c-0.071,0-0.142-0.03-0.191-0.089c-0.089-0.105-0.076-0.263,0.029-0.352 c27.067-22.903,48.503-52.342,61.988-85.132c0.053-0.128,0.199-0.188,0.327-0.137c0.127,0.053,0.188,0.199,0.136,0.326 c-13.516,32.864-34.999,62.369-62.128,85.323C192.753,430.095,192.695,430.114,192.638,430.114z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E4E0"
    },
    d: "M301.309,348.551c6.999,29.263,10.579,67.448,9.143,97.502h-19.206l-2.746-97.928 L301.309,348.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DD3E9"
    },
    d: "M288.5,348.125c10,37,8.87,97.928,8.87,97.928h-18.759L288.5,348.125z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBA58E"
    },
    points: "271.5,241.958 279.142,222.167 249.4,202.778 246.54,224.283 269.582,235.292  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M264.685,226.781c3.633,1.802,7.784,2.595,11.811,2.238l2.646-6.852l-29.214-19.044 c0.269,3.501,1.035,6.954,2.406,10.184C254.768,219.033,259.111,224.016,264.685,226.781z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DD3E9"
    },
    d: "M269.582,235.292l1.918,6.667l3.475-9l10.191,4.5l-6.667,9.667 c8,13.167,10.999,28.167,11.416,51.5l-24.821-51.5L269.582,235.292z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5FA5CC"
    },
    points: "285.167,237.458 285.917,248.042 280.271,244.556  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A8EFFA"
    },
    points: "242.731,232.104 244.962,223.528 269.582,235.292 263.946,250.156  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M263.946,250.406c-0.059,0-0.116-0.021-0.162-0.06l-18.674-15.89 c-0.105-0.089-0.118-0.247-0.028-0.352c0.09-0.105,0.247-0.117,0.353-0.028l18.404,15.661l4.819-12.712 c0.049-0.128,0.192-0.192,0.323-0.145c0.129,0.049,0.194,0.193,0.145,0.323l-4.945,13.043 c-0.029,0.076-0.093,0.133-0.172,0.153C263.987,250.403,263.967,250.406,263.946,250.406z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4CFBE"
    },
    d: "M239.775,193.691c-5.75-5.69-11.546-11.479-15.679-18.433 c-4.133-6.954-6.491-15.309-4.771-23.214c1.72-7.905,8.182-15.024,16.222-15.913c-2.604-2.787-1.623-7.165,0.883-10.041 c2.506-2.876,6.569-4.018,10.376-3.788c3.807,0.231,7.432,1.663,10.912,3.224c5.632-6.003,14.115-9.399,22.326-9.987 c3.458-0.247,7.167,0.131,9.924,2.234c2.757,2.103,4.068,6.355,2.048,9.173c4.459-1.964,10.091-0.622,13.976,2.319 c3.884,2.941,5.996,8.061,5.314,12.886c-0.682,4.824-3.722,10.058-9.291,11.969L254,199.292L239.775,193.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M254.282,195.783c-0.333-2.992-0.796-6.026-2.106-8.736c-1.311-2.71-3.599-5.089-6.514-5.84 c-2.075-0.535-4.317-0.204-6.266,0.685c-3.722,1.698-6.395,5.499-6.734,9.575c-0.339,4.077,1.668,8.267,5.057,10.557 c3.39,2.29,8.026,2.589,11.682,0.753c3.6,10.241,12.825,18.947,23.514,20.845c4.771,0.847,9.798,0.534,14.287-1.289 c5.763-2.339,10.361-7.056,13.36-12.506c2.999-5.45,4.508-11.607,5.301-17.777c1.633-12.716,0.306-25.803-3.847-37.933 c-4.892,1.039-9.907,1.942-14.884,1.451c-0.776,2.42-2.362,4.687-4.634,5.824c-2.113,1.057-4.565,1.297-6.915,1.043 c-2.35-0.254-4.622-0.977-6.849-1.766c1.076,4.61,0.71,9.649-1.458,13.858c-2.168,4.208-5.87,7.605-10.249,9.404 c0.211,1.899,0.612,4.098,0.299,5.982C257.01,191.801,255.879,194.734,254.282,195.783z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4CFBE"
    },
    d: "M278.531,167.821c3.502-0.717,6.948,0.324,9.447,2.506l-17.149,3.512 C272.27,170.85,275.029,168.539,278.531,167.821z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4CFBE"
    },
    d: "M301.016,167.722c2.286,0.534,3.952,2.68,4.684,5.561l-11.193-2.615 C296.346,168.388,298.73,167.188,301.016,167.722z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M280.323,183.968L280.323,183.968c1.266,0,2.292-1.026,2.292-2.292v-1.417 c0-1.266-1.026-2.292-2.292-2.292l0,0c-1.266,0-2.292,1.026-2.292,2.292v1.417 C278.032,182.942,279.058,183.968,280.323,183.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#422C4F"
    },
    d: "M300.858,183.968L300.858,183.968c0.82,0,1.486-0.665,1.486-1.486v-3.029 c0-0.821-0.665-1.486-1.486-1.486l0,0c-0.82,0-1.486,0.665-1.486,1.486v3.029 C299.373,183.302,300.038,183.968,300.858,183.968z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.066,205.095c2.261,2.965,6.126,4.625,9.833,4.222c3.707-0.403,7.125-2.855,8.696-6.237 c-1.567-2.287-3.919-4.277-6.311-5.677C291.407,199.739,286.941,202.758,283.066,205.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4CFBE"
    },
    d: "M294.632,194.609c-5.853,4.029-12.631,6.706-19.657,7.766c2.863,2.83,6.933,4.619,10.916,4.039 c3.984-0.58,7.635-3.114,9.572-6.643c1.432,1.928,3.123,4.364,5.427,5.042c1.367,0.402,2.887,0.258,4.155-0.393 s2.269-1.804,2.738-3.15C303.21,200.226,297.923,197.954,294.632,194.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E78882"
    },
    d: "M297.958,192.996c-2.681,0.051-5.361,0.102-8.042,0.153c0.973,1.025,1.984,2.147,3.345,2.529 c0.965,0.271,2.034,0.155,2.918-0.317C297.064,194.889,297.646,193.949,297.958,192.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E78882"
    },
    d: "M237.943,190.855c0.414-1.467,1.805-2.559,3.314-2.774c1.509-0.214,3.074,0.387,4.176,1.44 c1.102,1.052,1.762,2.516,1.999,4.021c0.196,1.242,0.092,2.601-0.65,3.616c-0.742,1.015-2.251,1.523-3.32,0.862 c-0.883-0.547-1.215-1.659-1.373-2.685c-0.122-0.8-0.174-1.652,0.164-2.387c0.338-0.735,1.181-1.293,1.956-1.06 c-0.721-0.926-1.68-1.578-2.829-1.819C240.233,189.83,238.974,190.296,237.943,190.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E78882"
    },
    d: "M268.398,177.455c2.688-3.45,4.159-7.83,4.1-12.203c3.116,1.636,7.267,2.203,10.548,0.93 c3.281-1.273,5.961-4.013,7.16-7.323c4.415,0.66,8.956,0.934,13.377,0.398c-0.47-1.728-0.988-3.443-1.569-5.137 c-4.892,1.039-9.907,1.942-14.884,1.451c-0.776,2.42-2.362,4.687-4.634,5.824c-2.114,1.057-4.565,1.297-6.915,1.043 c-2.35-0.254-4.622-0.977-6.849-1.766c1.076,4.61,0.71,9.649-1.458,13.858c-2.168,4.208-5.87,7.605-10.249,9.404 C261.398,183.934,265.71,180.905,268.398,177.455z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A59B95"
    },
    d: "M276.893,128.409c1.792-1.169,3.956-1.7,6.08-1.499c0.134,0.014,0.259-0.087,0.273-0.225 c0.013-0.138-0.088-0.26-0.225-0.273c-2.24-0.215-4.514,0.347-6.401,1.578c-1.885,1.231-3.313,3.087-4.02,5.225 c-0.003,0.008,0.003,0.015,0.002,0.022c-2.491-0.543-5.147-0.395-7.522,0.499c-3.364,1.265-6.191,4.004-7.561,7.328 c-0.053,0.127,0.008,0.274,0.136,0.326c0.031,0.013,0.064,0.019,0.095,0.019c0.098,0,0.191-0.058,0.231-0.155 c1.318-3.198,4.038-5.833,7.274-7.051c3.236-1.217,7.02-1.028,10.118,0.51c0.125,0.061,0.274,0.011,0.336-0.113 c0.061-0.124,0.011-0.274-0.113-0.336c-0.798-0.396-1.641-0.705-2.508-0.928C273.763,131.321,275.112,129.571,276.893,128.409 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A59B95"
    },
    d: "M238.3,135.962c2.371-1.247,5.196-1.504,7.752-0.708c2.557,0.797,4.735,2.614,5.977,4.986 c0.045,0.085,0.132,0.134,0.222,0.134c0.039,0,0.079-0.009,0.116-0.028c0.122-0.064,0.169-0.215,0.105-0.338 c-1.303-2.488-3.589-4.395-6.272-5.232c-2.681-0.836-5.645-0.565-8.132,0.743c-0.123,0.064-0.17,0.215-0.105,0.337 C238.027,135.98,238.179,136.026,238.3,135.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A59B95"
    },
    d: "M251.271,130.414c0.069,0,0.138-0.029,0.188-0.085c1.647-1.874,4.119-3.064,6.611-3.184 c2.505-0.11,5.067,0.83,6.886,2.537c0.1,0.095,0.26,0.09,0.353-0.011c0.095-0.101,0.09-0.259-0.011-0.353 c-1.917-1.799-4.627-2.809-7.252-2.671c-2.624,0.125-5.228,1.379-6.963,3.353c-0.091,0.104-0.081,0.262,0.023,0.353 C251.154,130.394,251.213,130.414,251.271,130.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A59B95"
    },
    d: "M250.867,151.217c-2.307-1.74-4.989-2.97-7.838-3.531c-4.147-0.819-8.511-0.225-12.289,1.667 c-0.124,0.062-0.173,0.212-0.112,0.335c0.062,0.124,0.212,0.173,0.335,0.112c3.68-1.843,7.931-2.418,11.969-1.624 c4.038,0.796,7.751,2.943,10.457,6.045c0.049,0.057,0.119,0.086,0.188,0.086c0.059,0,0.117-0.02,0.164-0.062 c0.105-0.091,0.115-0.248,0.024-0.352c-0.746-0.856-1.573-1.635-2.455-2.341c3.748-2.107,8.449-2.306,12.35-0.485 c0.125,0.059,0.273,0.005,0.333-0.121c0.059-0.125,0.004-0.274-0.121-0.332C259.758,148.694,254.785,148.93,250.867,151.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A59B95"
    },
    d: "M289.589,133.335c-2.59,0.317-5.007,1.533-6.805,3.424c-1.798,1.892-2.89,4.367-3.076,6.97 c-0.01,0.138,0.094,0.257,0.232,0.267c0.006,0.001,0.012,0.001,0.018,0.001c0.13,0,0.239-0.101,0.249-0.232 c0.175-2.452,1.246-4.879,2.94-6.661c1.693-1.782,4.063-2.974,6.503-3.273c0.137-0.017,0.235-0.141,0.218-0.278 C289.851,133.415,289.723,133.314,289.589,133.335z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454F6B"
    },
    d: "M411.968,259.869c-9.964,28.151-11.556,58.132-18.432,87.016 c-3.053,12.822-7.171,25.5-13.368,37.172c-5.977,11.257-14.679,24.064-26.213,30.278 c-17.013,9.166-26.448-11.745-30.582-24.582c-4.543-14.108-6.372-28.896-7.812-43.591 c-2.534-25.865-4.001-52.978-16.475-76.389c-1.152-2.161-2.455-4.248-3.856-6.287c2.259-16.067,2.828-32.216,1.655-48.346 c-0.869,1.018-1.808,1.967-2.806,2.849c0.852,14.003,0.392,28.038-1.392,41.983c-16.678-21.726-44.691-37.936-46.584-66.946 c-0.125-1.917-3.126-1.931-3,0c2.023,30.999,32.029,46.682,48.212,69.785c17.862,25.5,18.573,58.024,21.699,87.833 c1.596,15.22,3.82,30.557,9.221,44.954c3.683,9.818,9.908,22.548,21.707,23.939c12.181,1.436,22.802-10.807,29.471-19.419 c8.353-10.787,14.183-23.302,18.449-36.206c11.118-33.625,11.159-69.797,22.998-103.245 C415.506,258.843,412.608,258.058,411.968,259.869z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797C99"
    },
    d: "M421.005,238.983l-5.326,0.846l0.374,2.352c-2.895,3.768-4.217,10.357-3.081,17.508 c1.136,7.152,4.434,13.007,8.353,15.693l0.374,2.352l5.326-0.846c6.099-0.968,9.695-10.239,8.033-20.706 C433.396,245.714,427.104,238.014,421.005,238.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99A3B0"
    },
    d: "M429.732,257.027c1.662,10.467-1.934,19.738-8.033,20.706 c-6.099,0.969-12.39-6.732-14.052-17.199c-1.662-10.467,1.934-19.738,8.033-20.706 C421.779,238.86,428.07,246.56,429.732,257.027z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797C99"
    },
    d: "M410.962,245.389l-10.285,1.633l0.281,1.77c-2.178,2.835-3.173,7.792-2.318,13.173 c0.854,5.381,3.336,9.786,6.285,11.807l0.281,1.77l10.285-1.633c4.589-0.729,7.294-7.704,6.044-15.579 C420.285,250.454,415.551,244.66,410.962,245.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99A3B0"
    },
    d: "M411.25,259.962c1.251,7.875-1.455,14.85-6.044,15.579c-4.589,0.729-9.322-5.065-10.573-12.94 c-1.251-7.875,1.455-14.85,6.044-15.579C405.266,246.294,409.999,252.087,411.25,259.962z"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#797C99"
    },
    cx: 244.221,
    cy: 192.91,
    r: 2.84
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBA58E"
    },
    d: "M364.333,312.875L379,289.958c-1.82-9.904-1.68-19.8,0.331-29.667 c0.808-3.966,4.395-6.984,7.7-9.84c1.692-1.462,4.065-1.836,6.122-0.959c3.461,1.475,7.03,2.971,10.458,4.44 c1.397,0.599,2.291,1.985,2.264,3.504c-0.012,0.682-0.099,1.351-0.311,1.962c2.036-0.153,4.559-0.353,6.37,0.588 c1.927,1.001,3.148,3.221,2.96,5.385c1.75,0.347,3.541,0.807,4.932,1.926c1.94,1.56,2.604,4.509,1.52,6.75 c1.954,1.691,2.884,4.462,2.686,7.038c-0.199,2.577-1.189,5.017-2.168,7.408c-0.401,0.98-0.811,1.975-1.478,2.797 c-0.667,0.822-1.639,1.462-2.697,1.475c-1.059,0.013-2.148-0.747-2.275-1.798c-2.19,6.015-7.58,10.955-13.715,12.782 L387.5,326.625L364.333,312.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E78882"
    },
    d: "M364.333,312.875l23.167,13.75l6.294-10.139c-4.627-13.277-22.195-14.964-22.195-14.964 L364.333,312.875z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M388.334,266.325c-0.119,0-0.224-0.085-0.246-0.205c-0.293-1.612,0.805-3.077,2.022-3.813 c0.959-0.581,1.957-0.77,3.013-0.97c0.335-0.063,0.675-0.127,1.018-0.206c3.251-0.743,11.307-1.969,11.388-1.98 c0.145-0.022,0.264,0.074,0.284,0.21c0.021,0.136-0.073,0.264-0.21,0.284c-0.08,0.013-8.118,1.234-11.35,1.975 c-0.349,0.079-0.694,0.145-1.036,0.21c-1.01,0.19-1.965,0.371-2.846,0.905c-1.037,0.627-2.039,1.926-1.79,3.296 c0.024,0.136-0.065,0.267-0.201,0.291C388.363,266.324,388.349,266.325,388.334,266.325z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M397.545,269.111c-0.027,0-0.055-0.004-0.082-0.014c-0.13-0.045-0.199-0.188-0.154-0.318 c0.363-1.049,1.28-1.952,2.516-2.478c1.086-0.464,2.284-0.607,3.419-0.714c3.823-0.358,7.873-0.689,11.667-0.466 c0.138,0.009,0.243,0.127,0.235,0.265c-0.009,0.138-0.129,0.238-0.265,0.235c-3.757-0.224-7.786,0.106-11.591,0.464 c-1.095,0.104-2.25,0.24-3.271,0.676c-1.105,0.471-1.921,1.267-2.238,2.183C397.745,269.047,397.648,269.111,397.545,269.111 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M405.941,274.94c-0.106,0-0.204-0.067-0.238-0.174c-0.042-0.132,0.031-0.272,0.162-0.315 c5.091-1.619,10.754-1.852,15.543-0.647c0.134,0.033,0.215,0.169,0.181,0.304c-0.033,0.135-0.169,0.22-0.304,0.181 c-4.698-1.184-10.265-0.95-15.268,0.64C405.992,274.936,405.967,274.94,405.941,274.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M415.415,291.218c-0.013,0-0.026-0.001-0.04-0.003c-0.137-0.022-0.229-0.151-0.207-0.287 c0.56-3.412,0.595-6.25,0.106-8.674c-0.027-0.136,0.061-0.268,0.195-0.295c0.141-0.025,0.268,0.061,0.295,0.195 c0.501,2.485,0.467,5.381-0.103,8.854C415.642,291.131,415.535,291.218,415.415,291.218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M415.853,285.273c-0.07,0-0.141-0.029-0.19-0.088c-0.089-0.104-0.077-0.263,0.028-0.352 c0.968-0.827,1.793-1.799,2.454-2.889c0.071-0.117,0.226-0.153,0.344-0.084c0.118,0.071,0.155,0.225,0.084,0.344 c-0.688,1.135-1.549,2.147-2.558,3.01C415.969,285.254,415.911,285.273,415.853,285.273z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M255.127,304.244c-0.033,0-0.067-0.007-0.1-0.021c-6.962-3.023-13.122-8.163-17.345-14.471 c-0.077-0.114-0.046-0.27,0.068-0.347c0.115-0.076,0.27-0.046,0.347,0.069c4.171,6.229,10.253,11.304,17.129,14.289 c0.126,0.056,0.184,0.202,0.13,0.329C255.316,304.188,255.224,304.244,255.127,304.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M257.335,306.445c-6.37,0-12.63-1.666-18.163-4.842c-0.12-0.068-0.161-0.222-0.092-0.341 c0.069-0.121,0.223-0.162,0.341-0.093c5.72,3.282,12.232,4.938,18.821,4.764c0.151,0.006,0.253,0.105,0.256,0.244 c0.004,0.138-0.105,0.252-0.244,0.256C257.948,306.441,257.642,306.445,257.335,306.445z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249,299.292l50.157,82.792c12.368,20.415,41.601,21.475,55.416,2.011l39.894-56.209 c-4.684-14.542-16.42-24.998-31.582-26.871c-9.659,17.516-23.147,34.556-35.885,52.277 c-8.18-19.394-19.72-37.024-29.63-56.794c-5.995-11.96-10.562-24.608-16.691-36.485c-3.06-5.931-10.917-10.198-17.5-9.098 c-5.507,0.921-10.473,4.278-13.844,8.736c-3.441,4.551-5.301,10.173-5.885,15.849 C242.618,283.603,245.021,292.184,249,299.292z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M327,353.542c-0.009,0-0.019-0.001-0.028-0.002c-0.09-0.01-0.168-0.067-0.203-0.151 c-4.952-11.742-11.024-22.634-17.453-34.164c-4.063-7.287-8.263-14.822-12.169-22.614c-0.062-0.124-0.012-0.275,0.112-0.336 c0.12-0.062,0.273-0.012,0.335,0.111c3.901,7.782,8.099,15.313,12.159,22.595c6.361,11.41,12.373,22.192,17.304,33.805 c2.855-3.967,5.781-7.947,8.613-11.801c10.065-13.692,19.571-26.626,26.997-40.091c0.049-0.089,0.148-0.135,0.25-0.127 c5.938,0.732,11.419,2.761,16.29,6.027c0.114,0.077,0.144,0.232,0.068,0.348c-0.077,0.114-0.233,0.144-0.348,0.068 c-4.759-3.192-10.109-5.186-15.904-5.926c-7.429,13.439-16.912,26.341-26.949,39.996c-2.918,3.97-5.935,8.074-8.87,12.157 C327.156,353.504,327.08,353.542,327,353.542z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A59B95"
    },
    d: "M379.917,333.292c0,1.749-1.418,3.167-3.167,3.167s-3.167-1.418-3.167-3.167 s1.418-3.167,3.167-3.167S379.917,331.543,379.917,333.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A59B95"
    },
    d: "M373,343.542c0,1.749-1.418,3.167-3.167,3.167s-3.167-1.418-3.167-3.167 s1.418-3.167,3.167-3.167S373,341.793,373,343.542z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M313.833,378.208c-0.032,0-0.064-0.006-0.096-0.02c-0.127-0.053-0.188-0.199-0.135-0.326 c0.074-0.177,7.415-17.781,13.206-24.73c0.059-0.071,0.154-0.104,0.244-0.084c0.091,0.02,0.164,0.087,0.189,0.177 c2.48,8.845,2.757,23.994,2.759,24.146c0.002,0.138-0.108,0.252-0.246,0.254c-0.001,0-0.002,0-0.004,0 c-0.136,0-0.248-0.109-0.25-0.246c-0.002-0.148-0.269-14.713-2.613-23.553c-5.693,7.13-12.75,24.055-12.822,24.228 C314.024,378.15,313.932,378.208,313.833,378.208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M323.337,386.473c-0.09,0-0.178-0.05-0.222-0.136c-1.918-3.727-2.545-8.417-1.813-13.562 c0.652-4.58,2.245-8.985,3.786-13.245c0.047-0.13,0.193-0.194,0.32-0.15c0.13,0.047,0.197,0.19,0.15,0.32 c-1.532,4.236-3.116,8.617-3.761,13.146c-0.5,3.516-0.601,8.671,1.762,13.263c0.063,0.123,0.015,0.273-0.108,0.337 C323.415,386.464,323.376,386.473,323.337,386.473z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M323.84,379.14c-0.014,0-0.028-0.001-0.041-0.003c-0.136-0.023-0.229-0.152-0.206-0.288 l2.47-14.824c0.022-0.136,0.153-0.226,0.288-0.206c0.136,0.023,0.229,0.152,0.206,0.288l-2.47,14.824 C324.065,379.053,323.96,379.14,323.84,379.14z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E4E0"
    },
    d: "M365.079,363.892c-6.6,6.316-11.809,14.017-18.741,19.967 c-6.932,5.95-16.496,10.065-25.188,7.254c-7.178-2.321-12.128-8.739-16.528-14.866 c-18.133-25.256-34.863-51.518-50.088-78.627c-4.441-7.907-8.841-16.238-10.659-25.007c-0.175,0.959-0.326,1.921-0.425,2.888 c-0.833,8.103,1.57,16.684,5.549,23.791l50.157,82.792c12.367,20.415,41.601,21.475,55.416,2.011l19.336-27.244 C370.766,358.932,367.803,361.285,365.079,363.892z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222221"
    },
    d: "M327.542,398.315c-0.409,0-0.818-0.007-1.229-0.022c-11.286-0.409-21.518-6.421-27.37-16.08 l-50.157-82.791c-4.385-7.832-6.366-16.334-5.584-23.947c0.014-0.138,0.143-0.242,0.274-0.224 c0.138,0.015,0.237,0.138,0.223,0.274c-0.772,7.512,1.188,15.909,5.519,23.645l50.152,82.783 c5.764,9.516,15.843,15.436,26.96,15.841c11.123,0.405,21.599-4.771,28.038-13.844l39.894-56.209 c0.08-0.112,0.235-0.14,0.349-0.06c0.112,0.08,0.14,0.236,0.06,0.349l-39.894,56.209 C348.478,393.114,338.368,398.315,327.542,398.315z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 446.053,
    style: {
      fill: "#BD6C67"
    },
    width: 620,
    height: 17.572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 450.979,
    style: {
      fill: "#A64F5A"
    },
    width: 620,
    height: 12.646
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC6164"
    },
    d: "M640.09,190.385L640.09,190.385c-6.444-6.444-16.891-6.444-23.334,0l-6.758,6.758l-6.758-6.758 c-6.444-6.444-16.891-6.444-23.334,0c-6.444,6.444-6.444,16.891,0,23.335l6.758,6.758l23.335,23.335l23.335-23.335l6.758-6.758 C646.533,207.276,646.533,196.829,640.09,190.385z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "605.164,235.025 600.027,206.772 597.304,216.806 571.369,216.806 571.369,214.14  595.265,214.14 600.541,194.701 605.404,221.448 609.027,204.885 613.805,219.453 618.382,196.563 623.62,214.709  649.451,214.709 649.451,217.375 621.614,217.375 618.853,207.804 614.43,229.915 609.541,215.008  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2332 -0.9724 0.9724 0.2332 352.2234 634.7775)",
    style: {
      fill: "#6CA8BF"
    },
    cx: 578.628,
    cy: 94.042,
    rx: 34.925,
    ry: 34.925
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "600.091,86.328 586.341,86.328 586.341,72.579 570.915,72.579 570.915,86.328  557.165,86.328 557.165,101.755 570.915,101.755 570.915,115.504 586.341,115.504 586.341,101.755 600.091,101.755  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96E4FF"
    },
    d: "M201.638,241.344l-50.471,50.471c-1.738,1.738-4.555,1.738-6.292,0l-29.755-29.754 c-1.738-1.738-1.738-4.555,0-6.293l50.471-50.471c1.738-1.738,4.555-1.738,6.292,0l29.755,29.755 C203.375,236.789,203.375,239.607,201.638,241.344z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M131.736,254.547c-1.993,1.993-1.993,5.226,0,7.219l0,0c1.993,1.993,5.226,1.993,7.219,0 l4.911-4.912l-7.219-7.219L131.736,254.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC6164"
    },
    d: "M141.559,244.724l-4.911,4.911l7.219,7.219l4.911-4.911c1.994-1.993,1.993-5.226,0-7.219l0,0 C146.785,242.73,143.553,242.73,141.559,244.724z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M145.169,267.979c-1.993,1.993-1.993,5.226,0,7.219v0c1.993,1.993,5.226,1.993,7.219,0 l4.911-4.912l-7.219-7.219L145.169,267.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC6164"
    },
    d: "M154.992,258.156l-4.911,4.911l7.219,7.219l4.912-4.911c1.993-1.993,1.993-5.226,0-7.219h0 C160.217,256.163,156.985,256.163,154.992,258.156z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M154.546,231.737c-1.993,1.993-1.993,5.226,0,7.219l0,0c1.993,1.993,5.226,1.993,7.219,0 l4.911-4.911l-7.219-7.219L154.546,231.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC6164"
    },
    d: "M164.37,221.914l-4.912,4.911l7.219,7.219l4.911-4.912c1.994-1.993,1.994-5.226,0-7.219l0,0 C169.595,219.92,166.363,219.92,164.37,221.914z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M167.979,245.169c-1.993,1.993-1.993,5.226,0,7.219h0c1.993,1.993,5.226,1.993,7.219,0 l4.911-4.911l-7.219-7.219L167.979,245.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC6164"
    },
    d: "M177.802,235.346l-4.911,4.911l7.219,7.219l4.911-4.912c1.993-1.993,1.993-5.226,0-7.219l0,0 C183.028,233.353,179.796,233.353,177.802,235.346z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC6164"
    },
    d: "M209.796,92.633L209.796,92.633c-6.444-6.444-16.891-6.444-23.335,0l-6.758,6.758l-6.758-6.758 c-6.444-6.444-16.891-6.444-23.335,0c-6.444,6.444-6.444,16.891,0,23.335l6.758,6.758l23.335,23.335l23.335-23.335l6.758-6.758 C216.24,109.524,216.24,99.077,209.796,92.633z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "193.257,112.06 184.574,112.06 184.574,103.377 174.833,103.377 174.833,112.06  166.15,112.06 166.15,121.801 174.833,121.801 174.833,130.484 184.574,130.484 184.574,121.801 193.257,121.801  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.a6a34bf6a675e0ed7c408293def70149.svg";
export { ForwardRef as ReactComponent };